/**-------------------------------  Copyright ---------------------------------
This software has been developed by Orange Labs TGI/OLS/SOFT
Copyright (c) Orange Labs 2018

COPYRIGHT    : This file is the property of Orange Labs.
Copyright Orange Labs 2018, All Rights Reserved

This software is the confidential and proprietary information of Orange Labs.

You shall not disclose such Confidential Information and shall use it only
in accordance with the terms of the license agreement you entered into with
Orange Labs.

AUTHORS      : Orange Labs  TGI/OLS/SOFT
EMAIL        : soft.cybersec@orange.com
-----------------------------------------------------------------------------*/


import {HTTPService} from '@/services/HTTPService'
import {RuleSetVO} from '@/valueObjects/RuleSetVO'

export default class YaraService {
    private url = '/rule_sets'

    constructor(private httpService: HTTPService) {
    }

    public async getRuleSets(): Promise<RuleSetVO[]> {
        const rules = await this.httpService.get(this.url)
        return rules.data.map(RuleSetVO.fromServiceFormat)
    }

    public async getRuleSet(ruleSetId: number): Promise<RuleSetVO> {
        const rule = await this.httpService.get(this.url + '/' + ruleSetId)
        return RuleSetVO.fromServiceFormat(rule.data)
    }

    public async deleteRuleSet(rule: RuleSetVO): Promise<void> {
        const fullUrl = this.url + '/' + rule.id
        await this.httpService.delete(fullUrl)
    }

    public async saveRuleSet(rule: RuleSetVO): Promise<void> {
        const data = rule.toServiceFormat()
        await this.httpService.post(this.url, data)
    }

    public async patchRuleSet(rule: RuleSetVO): Promise<void> {
        const fullUrl = this.url + '/' + rule.id
        const data = rule.toServiceFormat()
        await this.httpService.patch(fullUrl, data)
    }

    public async getArtefact(): Promise<Blob> {
        const result = await this.httpService.get(this.url + '/archive', {responseType : 'blob'})
        const file = new Blob([result.data], {type: 'application/zip'})
        return file
    }

}
